import { useEffect, useState } from 'react'
import { Box, Container, Typography, TextField, Button, Alert, Paper } from '@mui/material'
import api from '../../services/api'
import PayrollHeader from './PayrollHeader'
import PayrollTabs from './PayrollTabs'

function PayrollNotes() {
  const [notesText, setNotesText] = useState('')
  const [savedText, setSavedText] = useState('')
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    api.get('/payroll/notes')
      .then((response) => {
        setNotesText(response.data.notes_text || '')
        setSavedText(response.data.notes_text || '')
      })
      .catch(() => setError('Failed to load notes'))
      .finally(() => setLoading(false))
  }, [])

  const hasUnsavedChanges = notesText !== savedText

  const handleSave = async () => {
    setSaving(true)
    setError('')
    setMessage('')
    try {
      await api.put('/payroll/notes', { notes_text: notesText })
      setSavedText(notesText)
      setMessage('Notes saved')
      setTimeout(() => setMessage(''), 3000)
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to save notes')
    } finally {
      setSaving(false)
    }
  }

  return (
    <Box>
      <PayrollHeader />
      <PayrollTabs />
      <Container maxWidth="md" sx={{ mt: 3, mb: 4 }}>
        <Typography variant="h6" gutterBottom>Notes</Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
          A shared scratchpad for planning notes - not tied to any specific month or pay run.
        </Typography>

        {message && <Alert severity="success" sx={{ mb: 2 }} onClose={() => setMessage('')}>{message}</Alert>}
        {error && <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>{error}</Alert>}

        <Paper variant="outlined" sx={{ p: 2 }}>
          <TextField
            fullWidth
            multiline
            minRows={22}
            maxRows={40}
            placeholder="Write your notes here..."
            value={notesText}
            onChange={(e) => setNotesText(e.target.value)}
            disabled={loading}
            InputProps={{ sx: { fontFamily: 'monospace', fontSize: 14 } }}
          />
        </Paper>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
          <Typography variant="caption" color="textSecondary">
            {hasUnsavedChanges ? 'Unsaved changes' : ' '}
          </Typography>
          <Button
            variant="contained"
            onClick={handleSave}
            disabled={loading || saving || !hasUnsavedChanges}
          >
            {saving ? 'Saving...' : 'Save'}
          </Button>
        </Box>
      </Container>
    </Box>
  )
}

export default PayrollNotes
